import { CSVFile, CSVRow, processCSV } from "@redotech/csv/csv-parser";
import { Currency } from "@redotech/money/currencies";
import { OrderImportField } from "@redotech/redo-fulfillment-common/import-schema";
import { CreateFulfillmentOrder } from "@redotech/redo-fulfillment-operations-common/create-fulfillment-order";
import { RedoShopifyCountryCode } from "@redotech/redo-inventory-common/fulfillment-country-code";
import {
  collectParseResults,
  FieldToColumnMap,
  ParseResult,
} from "./validate-fulfillment-orders";

export async function parseApparelMagicCsv(file: File): Promise<ParseResult> {
  const data: CSVFile = await processCSV(file);

  return collectParseResults(
    data.rows,
    async (row) => buildRow(row),
    (_, i) => `Row ${i + 1}`,
  );
}

function buildRow(row: CSVRow): CreateFulfillmentOrder {
  const name = row[ApparelMagicCsvColumns.NAME] ?? "";
  const address1 = row[ApparelMagicCsvColumns.STREET_ADDRESS] ?? "";
  const address2 = row[ApparelMagicCsvColumns.ADDRESS_2] ?? "";
  const city = row[ApparelMagicCsvColumns.CITY] ?? "";
  const state = row[ApparelMagicCsvColumns.STATE] ?? "";
  const zip = row[ApparelMagicCsvColumns.ZIP] ?? "";

  if (!name || !address1 || !city || !state || !zip) {
    throw new Error("Failed to parse row");
  }

  const data: CreateFulfillmentOrder = {
    address: {
      countryCode: RedoShopifyCountryCode.Us,
      name,
      address1,
      address2,
      city,
      province: state,
      zip,
    },
    orderInfo: {
      orderNumber: "",
      orderDate: new Date(),
      paidDate: new Date(),
      shippingPaid: { amount: "0", currency: Currency.USD },
      taxPaid: { amount: "0", currency: Currency.USD },
      totalPaid: { amount: "0", currency: Currency.USD },
      items: [],
      internalNote: "",
    },
  };
  return data;
}

export enum ApparelMagicCsvColumns {
  NAME = "Name*",
  STREET_ADDRESS = "Street Address*",
  ADDRESS_2 = "Address 2",
  CITY = "City*",
  STATE = "State*",
  ZIP = "Zip*",
  DIMS = "Dims (in)",
  WEIGHT = "Weight (lbs)",
}

export const apparelMagicColumnMap: FieldToColumnMap = {
  [OrderImportField.RECIPIENT_FULL_NAME]: ApparelMagicCsvColumns.NAME,
  [OrderImportField.ADDRESS_LINE_1]: ApparelMagicCsvColumns.STREET_ADDRESS,
  [OrderImportField.ADDRESS_LINE_2]: ApparelMagicCsvColumns.ADDRESS_2,
  [OrderImportField.CITY]: ApparelMagicCsvColumns.CITY,
  [OrderImportField.STATE]: ApparelMagicCsvColumns.STATE,
  [OrderImportField.POSTAL_CODE]: ApparelMagicCsvColumns.ZIP,
};
